<template>
  <div class="buy-recode">
    <!-- //购买记录 -->
    <el-row class="t-header">
      <el-col :span="6">商品名称</el-col>
      <el-col :span="4">下单时间</el-col>
      <el-col :span="4">订单状态</el-col>
      <el-col :span="2">单价</el-col>
      <el-col :span="2">数量</el-col>
      <el-col :span="2">实付金额</el-col>
      <el-col :span="4">操作</el-col>
    </el-row>
    <el-row class="content" v-if="resultData.list&&resultData.list.length>0" v-loading="tableLoading">
      <el-row class="content-item" v-for="(item,index) in resultData.list" :key="index">
        <!-- <p>具备强感知能力的固态面阵激光雷达技解析|车辆感知第七讲</p> -->
        <el-row class="title">
          <el-col :span="10">
            <span class="label-title">订单号：{{item.order_no}}</span>
          </el-col>
          <el-col :span="10">
            <span class="label-title">支付方式：微信支付</span>
          </el-col>
          <el-col :span="4">
            <span class="label-title">操作方式：自有服务好账户</span>
          </el-col>
        </el-row>
        <el-row class="info">
          <el-col :span="6">{{item.goods_name}}</el-col>
          <el-col :span="4">{{item.pay_at}}</el-col>
          <el-col :span="4">
            <span v-show="item.pay_state==1">待支付</span>
            <span v-show="item.pay_state==2">已支付</span>
            <span v-show="item.pay_state==3">已退款</span>
            <span v-show="item.pay_state==4">支付失败</span>
          </el-col>
          <el-col :span="2">{{item.goods_price}}</el-col>
          <el-col :span="2">{{item.goods_quantity}}</el-col>
          <el-col :span="2">{{item.total_amount}}</el-col>
          <el-col :span="4" class="blue cp">
            <span  @click="orderDecript(item)">订单详情</span>
          </el-col>
        </el-row>
      </el-row>
    </el-row>

    <div class="tc mt40">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page="Number(search.page)"
        :page-size="Number(search.size)"
        layout="total, prev, pager, next"
        :total="Number(resultData.count)"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
//获取信息采集的记录
import { _userOrderBuy } from "@/api/order.js";

export default {
  created() {
    this.userOrderBuy();
  },
  props: {
    user_id: {
      type: String,
      default:''
    }
  },
  components: {},
  data() {
    return {
      tableLoading:false,
      search: {
        page: 1,
        size: 10
      },
      // name type num money date
      resultData: {}
    };
  },
  methods: {
    //翻页
    handleCurrentChange(val) {
      this.search.page = val
      this.userOrderBuy()
    },
    reply(item) {
      this.privateDialogVisible = true;
    },
    //获取购买的信息
    userOrderBuy() {
      this.tableLoading=true;
      _userOrderBuy({
        params: {
          page: this.search.page,
          size: this.search.size,
          user_id: this.user_id
        }
      }).then(res => {
        this.tableLoading=false;
        if (res.resultCode == 1) {
          this.resultData = res.result;
        } else {
          tiis.$message.error(res.errorMsg);
        }
      });
    },
     //订单详情
    orderDecript(item) {
      let routeData = this.$router.resolve({
        path: `/payment/order/descript/${item.order_id}`
      });
      window.open(routeData.href, "_blank");
    }
  }
};
</script>

<style scoped lang="less">
.buy-recode {
  .t-header {
    margin-top: 20px;
    background-color: @table-bg;
    height: 40px;
    line-height: 40px;
    padding: 0 20px;
    font-weight: bold;
  }
  .content {
    .content-item {
      .title {
        height: 40px;
        line-height: 40px;
        color: @gray;
        padding: 0 20px;
      }
      .info {
        background-color: #fefefe;
        height: 60px;
        line-height: 60px;
        padding: 0 20px;
        font-weight: 500;
      }
    }
  }
}
</style>